'use client'

import { usePathname } from 'next/navigation'
import { useSession } from 'next-auth/react'
import { TailSpin } from 'react-loader-spinner'

import Sidebar from './sidebar'

const DashboardSidebar = () => {
  const session = useSession()
  const path = usePathname()

  if (!path.includes('/dashboard/login') && session.status === 'loading') {
    return (
      <div className="flex w-[200px] items-center justify-center">
        <TailSpin
          ariaLabel="Carregando..."
          color="#00A180"
          width={40}
          height={40}
        />
      </div>
    )
  }

  if (path.includes('/dashboard/login')) {
    return null
  }

  return <Sidebar session={session} />
}

export default DashboardSidebar
